var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3909 1.8916H13.6409V0.641602H12.3909V1.8916H4.14087V0.641602H2.89087V1.8916H2.14087C1.10699 1.8916 0.265869 2.73273 0.265869 3.7666V14.7666C0.265869 15.8005 1.10699 16.6416 2.14087 16.6416H14.3909C15.4247 16.6416 16.2659 15.8005 16.2659 14.7666V3.7666C16.2659 2.73273 15.4247 1.8916 14.3909 1.8916ZM15.0159 14.7666C15.0159 15.1112 14.7355 15.3916 14.3909 15.3916H2.14087C1.79624 15.3916 1.51587 15.1112 1.51587 14.7666V6.5166H15.0159V14.7666ZM15.0159 5.2666H1.51587V3.7666C1.51587 3.42198 1.79624 3.1416 2.14087 3.1416H2.89087V4.3916H4.14087V3.1416H12.3909V4.3916H13.6409V3.1416H14.3909C14.7355 3.1416 15.0159 3.42198 15.0159 3.7666V5.2666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64087 7.8291H3.89087V9.0791H2.64087V7.8291ZM5.14087 7.8291H6.39087V9.0791H5.14087V7.8291ZM7.64087 7.8291H8.89087V9.0791H7.64087V7.8291ZM10.1409 7.8291H11.3909V9.0791H10.1409V7.8291ZM12.6409 7.8291H13.8909V9.0791H12.6409V7.8291ZM2.64087 10.3291H3.89087V11.5791H2.64087V10.3291ZM5.14087 10.3291H6.39087V11.5791H5.14087V10.3291ZM7.64087 10.3291H8.89087V11.5791H7.64087V10.3291ZM10.1409 10.3291H11.3909V11.5791H10.1409V10.3291ZM2.64087 12.8291H3.89087V14.0791H2.64087V12.8291ZM5.14087 12.8291H6.39087V14.0791H5.14087V12.8291ZM7.64087 12.8291H8.89087V14.0791H7.64087V12.8291ZM10.1409 12.8291H11.3909V14.0791H10.1409V12.8291ZM12.6409 10.3291H13.8909V11.5791H12.6409V10.3291Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.265869 0.641602)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.e678ef69989cfd060f6fca990bf19f9c.svg";
export { ForwardRef as ReactComponent };